// Wave 2 (2026-10-05): "Mark handled" on the SMS needs-attention page.
//
// The ROUTE is chosen by the bucket a row sits in, never by which fields the
// row happens to carry: failed/expired rows carry BOTH row_id and dedupe_key,
// and must never be marked through the consent-block route (wrong table).
// Unknown buckets or missing ids get no request at all (no button).

export const QUEUE_BUCKETS = ["failed", "expired"];
export const BLOCK_BUCKET = "blocked";
// P-6 (2026-10-10): "other" replies, marked handled on the portal's own
// sms_inbound_messages row.
export const REPLY_BUCKET = "replies";

export function handledKey(bucket, row) {
  if (QUEUE_BUCKETS.includes(bucket)) return `row:${row && row.row_id}`;
  if (bucket === BLOCK_BUCKET) return `block:${row && row.dedupe_key}`;
  if (bucket === REPLY_BUCKET) return `reply:${row && row.reply_id}`;
  return null;
}

export function handledRequest(bucket, row) {
  if (!row) return null;
  if (QUEUE_BUCKETS.includes(bucket)) {
    if (row.row_id === null || row.row_id === undefined || row.row_id === "") return null;
    return { url: `/crm/sms/needs-attention/${encodeURIComponent(row.row_id)}/handled`, body: undefined };
  }
  if (bucket === BLOCK_BUCKET) {
    if (!row.dedupe_key) return null;
    return { url: "/crm/sms/needs-attention/block-handled", body: { dedupe_key: row.dedupe_key } };
  }
  if (bucket === REPLY_BUCKET) {
    if (row.reply_id === null || row.reply_id === undefined || row.reply_id === "") return null;
    return { url: `/crm/sms/needs-attention/reply/${encodeURIComponent(row.reply_id)}/handled`, body: undefined };
  }
  return null;
}

export function handledErrorCopy(status) {
  if (status === 404) return "That item is already gone. Refreshing the list.";
  if (status === 409) return "That item changed. Take another look before marking it.";
  if (status === 503) return "The SMS queue is not reachable right now. Try again shortly.";
  if (status === 403) return "Only sales and admin can mark items handled.";
  return "Could not mark that handled. Try again.";
}
